<!-- src/views/NotFound.vue -->
<template>
    <div class="pa-4">
        <div class="text-center py-10 px-4 mt-5">
            <v-img src="/img/404.png" alt="Akr-halaman-tidak-ditemukan" cover></v-img>
            <h2 class="text-h6 font-weight-bold mb-2">404 - Halaman Tidak Ditemukan</h2>
            <p class="text-body-2 mb-6" style="max-width: 500px;">
                Maaf, halaman yang Anda cari tidak dapat ditemukan. Mungkin tautan sudah tidak aktif, telah dipindahkan,
                atau terjadi kesalahan penulisan alamat.
            </p>

            <v-btn size="small" variant="tonal" class="rounded-pill" color="primary" to="/">
                Kembali ke Beranda
            </v-btn>
        </div>
    </div>
</template>
